import baseState from "./baseState";

export const state = {
  projectId: baseState.projectId,
  projectProperties: baseState.projectProperties,
  configuration: baseState.configuration,
  pous: baseState.pous,
  dataTypes: baseState.dataTypes,

  addItem: baseState.addItem,
  showLoading: false,

  commonPous: baseState.commonPous,
};
